import { ChangePasswordLoggedValueObject, ChangePasswordValueObject, PutPassword } from "../model/IdentitiModel";
import { ApiAuth } from "../services/api";

export async function GetValidateCode(code: string) {
    const request = await ApiAuth.get<any>("api/UserInfoPassword/" + code);
  
    return request.data;
  }

  export async function PutNewPassword(putPassword: PutPassword) {
    const request = await ApiAuth.put<any>("api/UserInfoPassword/", putPassword );
  
    return request.data;
  }

  export const putMfaKey = async (email: string) => {
    const request = await ApiAuth.put(`api/UserInfoPassword/mfaKey`, { email });

    return request.data;
  }

  export const ChangePasswordAccess = async (changePasswordValueObject: ChangePasswordValueObject) => {
    const request = await ApiAuth.put(`api/UserInfoPassword/changePasswordAccess`, changePasswordValueObject);
    return request.data;
  }

  export const ChangePasswordLogged = async (changePasswordValueObject: ChangePasswordLoggedValueObject) => {
    const request = await ApiAuth.put(`api/UserInfoPassword/changePasswordLogged`, changePasswordValueObject);
    return request.data;
  }